/**
 * Mapping dynamique : iconName (string en BDD) → composant lucide-react
 * Utilisé par les composants d'affichage pour résoudre les icônes stockées en base.
 */

import {
  Building2,
  Monitor,
  Users,
  Wifi,
  Coffee,
  Printer,
  ShieldCheck,
  Projector,
  UtensilsCrossed,
  Headphones,
  Key,
  FileText,
  Clock,
  Info,
  Sparkles,
  ArrowRight,
  ArrowLeft,
  Camera,
  Mic,
  Music,
  Palette,
  Settings,
  Star,
  Zap,
  Calendar,
  Timer,
  Briefcase,
  MapPin,
  Phone,
  Mail,
  Heart,
  CheckCircle,
  AlertCircle,
  type LucideIcon,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  Building2,
  Monitor,
  Users,
  Wifi,
  Coffee,
  Printer,
  ShieldCheck,
  Projector,
  UtensilsCrossed,
  Headphones,
  Key,
  FileText,
  Clock,
  Info,
  Sparkles,
  ArrowRight,
  ArrowLeft,
  Camera,
  Mic,
  Music,
  Palette,
  Settings,
  Star,
  Zap,
  Calendar,
  Timer,
  Briefcase,
  MapPin,
  Phone,
  Mail,
  Heart,
  CheckCircle,
  AlertCircle,
};

/**
 * Résout un nom d'icône (string) en composant lucide-react.
 * Retourne Building2 par défaut si le nom est inconnu.
 */
export function getIcon(name?: string | null): LucideIcon {
  if (!name) return Building2;
  return ICON_MAP[name] || Building2;
}

/**
 * Vérifie si un nom d'icône est valide (existe dans le mapping).
 */
export function isValidIconName(name: string): boolean {
  return name in ICON_MAP;
}

/**
 * Liste des noms d'icônes disponibles (utile pour l'admin).
 */
export function getAvailableIconNames(): string[] {
  return Object.keys(ICON_MAP);
}
